class Rating {
	constructor() {
		this.init();
	}

	init() {
		window.od.events.subscribe(
			'algolia_hybrisEnrichment_renderedProductTiles',
			({ element }) => this.loadTrustpilotWidgets(element),
		);

		window.addEventListener('message', event =>
			this.handleTrustpilotMessage(event),
		);
	}

	loadTrustpilotWidgets(element) {
		if (!element || !window.Trustpilot?.loadFromElement) {
			return;
		}

		const trustpilotWidgets = element.querySelectorAll('.trustpilot-widget');

		trustpilotWidgets.forEach(widget => {
			window.Trustpilot.loadFromElement(widget, true);
		});
	}

	handleTrustpilotMessage(event) {
		const iframe = Array.from(
			document.querySelectorAll(
				'.trustpilot-widget[data-pdp-review-url] iframe',
			),
		).find(({ contentWindow }) => contentWindow === event.source);

		if (!iframe) {
			return;
		}

		let eventData = event.data;

		if (typeof eventData === 'string') {
			try {
				eventData = JSON.parse(eventData);
			} catch {
				return;
			}
		}

		if (eventData?.command !== 'scrollTo') {
			return;
		}

		const pdpReviewUrl =
			iframe.closest('.trustpilot-widget')?.dataset.pdpReviewUrl;

		if (!pdpReviewUrl) {
			return;
		}

		const url = new URL(pdpReviewUrl, window.location.origin);
		url.searchParams.set('scrollTo', 'productReviews');

		this.navigate(url.toString());
	}

	navigate(url) {
		window.location.assign(url);
	}
}

export default Rating;
